"use client"

import Title from "@/components/common/Typography/Title"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import { Col, Row } from "antd"
import Image from "next/image"
import { FC } from "react"
import { useTranslation } from "react-i18next"

const IntroTEApp: FC<any> = () => {
  const { t } = useTranslation()
  const isDesktop = useIsDesktop()

  if (!isDesktop) {
    return <></>
  }

  return (
    <Row className="home__introapp" justify='center'>
      <Col span={24} className="home__introapp-content">
        <Row wrap={false} className="home__introapp-content--left">
          <Col>
            <Row style={{ height: '100%' }} align='bottom'>
              <Col style={{ display: 'flex', alignItems: 'flex-end', height: '100%' }}>
              <img
                src="/static/mockup.png"
                width={395}
                height={357}
                alt="Preview te app"
                style={{ display: 'block' }}
              />
              </Col>
            </Row>
          </Col>
          <Col flex={1} className="home__introapp-content--right">
            <Row justify='center' align='middle'>
              <Col className="home__introapp-content--right-content">
                <Row>
                  <Title level={2} className="home__introapp-content--right-title">
                    {t("home.section_installation_app_title")}
                  </Title>
                </Row>
                <Row>
                  <Title level={4} className="home__introapp-content--right-subtitle">
                    {t("home.section_installation_app_desc")}
                  </Title>
                </Row>
                <Row>
                  <Image
                    // className="home__introapp-content--qrcode-zalo"
                    src={"/static/QR.jpg"}
                    height={148}
                    width={148}
                    alt="QR code download app"
                  />
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

IntroTEApp.displayName = 'IntroTEApp'

export default IntroTEApp